import { GraduationServicePath } from "utils/constants";
import permissions from "app/permissions";
import CreateStateExamsResults from "./Create";

export const resources = {
  isMenu: false,
  name: GraduationServicePath + "add-state-exams-results/:id",
  title: "Резултати държавен изпит",
  create: <CreateStateExamsResults />,
  permission: permissions.canManageStateExamResults,
};
